import config from 'config';

import type { ProductsInformation, ShoppingBagProduct } from './types';

const setId = config.get('public.productTypes.setId');
export const isSetShoppingBagProduct = ({
  productTypeId,
}: ShoppingBagProduct) => productTypeId === setId;
export const isNextSetShoppingBagProduct = (
  productsList: ProductsInformation[],
  index: number
): boolean => {
  const nextItem = productsList[index + 1];
  if (!nextItem) {
    return false;
  }
  return isSetShoppingBagProduct(nextItem?.product);
};

export const isLastOfCurrentPromo = (
  productsList: ProductsInformation[],
  index: number
) => {
  const currentId = productsList[index].upsellInformation?.fplId;
  const nextItem = productsList[index + 1];
  if (!nextItem) {
    return true;
  }
  return currentId !== nextItem.upsellInformation?.fplId;
};

// temporary handler until quantity field for sets is everywhere, to avoid non-numeric values
const getSetShoppingBagQuantity = (product: ShoppingBagProduct) => {
  return product.availableQuantityAnyComponent ?? product.availableQuantity;
};

export const getProductTargetQuantity = (
  product: ShoppingBagProduct,
  isPreorderable: boolean = false
) => {
  if (isPreorderable) {
    return product.availableQuantityPreorder;
  }
  if (isSetShoppingBagProduct(product)) {
    return getSetShoppingBagQuantity(product);
  }
  return product.availableQuantity;
};
